export const getLocalStorageItem = (key: string): any => {
  if (typeof window === 'undefined') return null;

  try {
    const storedValue = window.localStorage.getItem(key);
    if (storedValue === null) return null;

    try {
      return JSON.parse(storedValue);
    } catch (error) {
      console.error(`Could not parse local storage value for "${key}".`, error);
      try {
        window.localStorage.removeItem(key);
      } catch (removeError) {
        console.error(`Could not remove invalid local storage value for "${key}".`, removeError);
      }
      return null;
    }
  } catch (error) {
    console.error(`Could not read local storage value for "${key}".`, error);
    return null;
  }
};

export const setLocalStorageItem = (key: string, value: any): void => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(key, JSON.stringify(value));
};

export const removeLocalStorageItem = (key: string): void => {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(key);
};
